<template>
    <div class="mt-26">
        <div class="text-center text-16 font-medium mb-4">
            กรอกข้อมูลเข้าสู่ระบบ
        </div>
        <div class="mb-2">
            <InputNationalId v-model:inputValue="inputValue" :inputLbl="inputLbl" :errorInfo="errInfo[0]" :hideLabel="true"
                :isShowError="false" :isSubmitted="isSubmitted" />
        </div>
        <div>
            
            <OrangeButton
                :customClass="`w-full py-3 text-14 rounded-10 bg-a-orange-f36e21`"
                @click="submit()">
                ยืนยัน
            </OrangeButton>
        </div>
        <template v-if="hasError || showError">
            <div class="text-center mt-4 text-a-red-fe2526 text-12 leading-relaxed">
                <div class="mb-2.5">
                    ขออภัยข้อมูลไม่ถูกต้อง
                </div>
                <div>
                    กรุณาติดต่อศูนย์บริการลูกค้า<br />
                    โทร. <a class="underline" href="tel:023089222">02-308-9222</a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { FormHelper } from '@/helper/FormHelper';
import { computed, defineComponent, nextTick, ref } from 'vue';

// component
import InputNationalId from '@/components/Input/label/InputNationalId.vue';

import OrangeButton from '../../../../components/Button/OrangeButton.vue';

export default defineComponent({
    props: {
        modelValue: {
            type: String
        },
        showError:{
            type: Boolean
        }
    },
    emits: ["update:modelValue", "submit"],
    setup: function (props, ctx) {
        const inputLbl = {
            name: "",
            placeholder: "หมายเลขบัตรประชาชน 13 หลัก",
            required: "กรุณากรอกหมายเลขบัตรประชาชน 13 หลัก",
            too_short: "13 digits",
            invalid: "invalid format"
        }

        const isSubmitted = ref(false)
        const errInfo = ref(FormHelper.genErrorInfo(1))

        const hasError = computed(() => {
            if (isSubmitted.value && !FormHelper.validate(errInfo.value)) {
                return true
            }
            return false
        })

        const inputValue = computed({
            get: function () {
                return props.modelValue
            },
            set: function (val) {
                ctx.emit("update:modelValue", val)
            }
        })

        const submit = function () {
            isSubmitted.value = true

            nextTick(() => {
                if (hasError.value) return

                ctx.emit("submit")
            })
        }

        return {
            inputValue,
            inputLbl,
            errInfo,
            isSubmitted,
            hasError,
            submit
        }
    },
    components: {
        InputNationalId,
        OrangeButton
        // MainButton,
    }
})
</script>


